import { render, staticRenderFns } from "./SortOrder.vue?vue&type=template&id=73d324f6&scoped=true&"
import script from "./SortOrder.vue?vue&type=script&lang=js&"
export * from "./SortOrder.vue?vue&type=script&lang=js&"
import style0 from "./SortOrder.vue?vue&type=style&index=0&id=73d324f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d324f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
